"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bar = require("@nivo/bar");

// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.
const ParticipantsByMonthBarChart = ({
  data
  /* see data tab */

}) => /*#__PURE__*/_react.default.createElement(_bar.ResponsiveBar, {
  data: data,
  keys: ['Active', 'Accepted', 'Dismissed', 'Dropped', 'Finished'],
  indexBy: "month",
  margin: {
    top: 50,
    right: 130,
    bottom: 50,
    left: 60
  },
  padding: 0.3,
  colors: {
    scheme: 'nivo'
  },
  defs: [{
    id: 'dots',
    type: 'patternDots',
    background: 'inherit',
    color: '#38bcb2',
    size: 4,
    padding: 1,
    stagger: true
  }, {
    id: 'lines',
    type: 'patternLines',
    background: 'inherit',
    color: '#eed312',
    rotation: -45,
    lineWidth: 6,
    spacing: 10
  }],
  fill: [{
    match: {
      id: 'Dismissed'
    },
    id: 'dots'
  }, {
    match: {
      id: 'Dropped'
    },
    id: 'lines'
  }],
  borderColor: {
    from: 'color',
    modifiers: [['darker', 1.6]]
  },
  axisTop: null,
  axisRight: null,
  axisBottom: {
    tickSize: 5,
    tickPadding: 5,
    tickRotation: 0,
    legend: 'Month',
    legendPosition: 'middle',
    legendOffset: 32
  },
  axisLeft: {
    tickSize: 5,
    tickPadding: 5,
    tickRotation: 0,
    legend: 'Participants',
    legendPosition: 'middle',
    legendOffset: -40
  },
  labelSkipWidth: 12,
  labelSkipHeight: 12,
  labelTextColor: {
    from: 'color',
    modifiers: [['darker', 1.6]]
  },
  legends: [{
    dataFrom: 'keys',
    anchor: 'bottom-right',
    direction: 'column',
    justify: false,
    translateX: 120,
    translateY: 0,
    itemsSpacing: 2,
    itemWidth: 100,
    itemHeight: 20,
    itemDirection: 'left-to-right',
    itemOpacity: 0.85,
    symbolSize: 20,
    effects: [{
      on: 'hover',
      style: {
        itemOpacity: 1
      }
    }]
  }],
  animate: true,
  motionStiffness: 90,
  motionDamping: 15
});

var _default = ParticipantsByMonthBarChart;
exports.default = _default;